module.exports = __webpack_public_path__ + "media/noti-1.6af7f50a.wav";